import PortoGoalsPage from "./PortoGoalsPage";
export default PortoGoalsPage;
